const defaultNames = {
  'processmaker-modeler-start-event': 'Iniciar Evento',
  // 'processmaker-modeler-start-timer-event': 'Start Timer Event',
  // 'processmaker-modeler-signal-start-event': 'Signal Start Event',
  // 'processmaker-modeler-message-start-event': 'Message Start Event',
  // 'processmaker-modeler-conditional-start-event': 'Conditional Start Event',
};

export default defaultNames;
